import styled from 'styled-components';
import { common } from 'themes/default';

const BookingMagnetContainer = styled.div`
  max-width: 1024px;
  margin: auto;
  padding: 25px;
`;

const BookingForm = styled.form`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  margin-bottom: ${({ avoidContentJumping }) => (avoidContentJumping ? '300px;' : '153px')};
`;

const ClearButtonContainer = styled.div.attrs({
  'data-id': 'ClearButtonContainer'
})`
  margin-left: 15px;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`;
const BoldLabel = styled.div`
  font-weight: bold;
`;

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  .switch-label {
    display: flex;
    height: 20px;
    align-items: center;
  }
`;

const PaxSelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 25px;
  width: 100%;

  > :nth-child(1) {
    width: 100%;
  }

  > :nth-child(2) {
    width: 40%;
  }

  .bold {
    font-weight: 600;
  }

  .pax-details {
    text-align: right;
  }
`;

const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  margin-top: 32px;
  align-items: flex-end;

  > div {
    select {
      width: 200px;
    }

    button {
      margin: 0;
    }
  }

  > div:not(:last-of-type) {
    margin-right: 32px;
  }
`;

const Header = styled.h1`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const { reactSwitch: switchColours } = common;

export {
  BoldLabel,
  BookingMagnetContainer,
  BookingForm,
  ClearButtonContainer,
  HeaderContainer,
  SwitchContainer,
  PaxSelectionContainer,
  SelectContainer,
  switchColours,
  Header
};
